import { create } from 'zustand';

export type PendingBet = {
	id: string;
	stake: number;
	payout: number | null;
	gasUsed?: number;
	timestamp: number;
	resolved: boolean;
	currencyType: string;
};

interface PendingBetStore {
	bets: PendingBet[];
	addPendingBet: (stake: number, currencyType: string, id?: string) => string;
	resolvePendingBet: (betId: string) => void;
	setPendingBetPayout: (betId: string, payout: number) => void;
	setPendingBetGas: (betId: string, gasUsed: number) => void;
	clearByCurrency: (currencyType: string) => void;
	removePendingBet: (betId: string) => void;
}

export const usePendingBetStore = create<PendingBetStore>((set) => ({
	bets: [],
	addPendingBet: (stake, currencyType, id) => {
		const betId = id ?? crypto.randomUUID();
		const bet: PendingBet = {
			id: betId,
			stake,
			payout: null,
			gasUsed: 0,
			timestamp: Date.now(),
			resolved: false,
			currencyType,
		};
		set((state) => ({ bets: [...state.bets, bet] }));
		return betId;
	},
	resolvePendingBet: (betId) =>
		set((state) => ({
			bets: state.bets.map((bet) => (bet.id === betId ? { ...bet, resolved: true } : bet)),
		})),
	setPendingBetPayout: (betId, payout) =>
		set((state) => ({
			bets: state.bets.map((bet) => (bet.id === betId ? { ...bet, payout } : bet)),
		})),
	setPendingBetGas: (betId, gasUsed) =>
		set((state) => ({
			bets: state.bets.map((bet) => (bet.id === betId ? { ...bet, gasUsed } : bet)),
		})),
	clearByCurrency: (currencyType) =>
		set((state) => ({
			bets: state.bets.filter((bet) => bet.currencyType !== currencyType),
		})),
	removePendingBet: (betId) =>
		set((state) => ({
			bets: state.bets.filter((bet) => bet.id !== betId),
		})),
}));
